export default __webpack_public_path__ + "img/8f17364e1e1a1920f6aa3f1d9c505728.png";